export default __webpack_public_path__ + "static/media/horizontal2.f91d002d.JPG";